/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import {  Menu } from '@mui/icons-material';
import { AppBar, Toolbar, useTheme, Box, Button, Grid, IconButton, Dialog, DialogTitle } from '@mui/material';
import MainLogo from "../images/digiacc.png"

interface IProps {
    drawerToggle: () => void,
}

const logoMain = css({
    height: "1.6rem",
    filter: "brightness(0) invert(1)",
})

const Appbar = (props: IProps): JSX.Element => {

    const theme = useTheme();

    return <>
        <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: theme.palette.info.light }}>
            <Toolbar>
                <Grid container>
                    <Grid item>
                        <IconButton onClick={props.drawerToggle}
                            sx={{ color: theme.palette.background.paper }}>
                            <Menu fontSize="large" />
                        </IconButton>
                    </Grid>
                    <Grid item>
                        <Box
                            component={Button}
                            display="flex" justifyContent="center" alignItems="center"
                            width="100%">
                            <img src={MainLogo} css={logoMain} />
                        </Box>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
        <Toolbar />
    </>

}

export default Appbar;